import api from "@/api";

import {
  AUTH_SETTINGS,
  AUTH_SETTINGS_BY_GROUP,
  AUTH_SETTINGS_BY_PREMISE,
  AUTH_LOGIN,
  AUTH_LOGOUT
} from "./types";
import { GET_PERSONAL_ACCOUNT_INFO } from "@/apps/user/store/types";
import { GET_MANAGE_ORGANIZATION_INFO } from "@/apps/main/store/types";

export default {
  [AUTH_SETTINGS]: async ({ commit }, data) => {
    const resp = await api.auth.getSettingsAuth(data);
    commit(AUTH_SETTINGS, await resp.data);
    return resp.data;
  },

  [AUTH_SETTINGS_BY_GROUP]: async ({ commit }, manageOrganizationGroupId) => {
    const resp = await api.auth.getSettingsAuthByGroup(
      manageOrganizationGroupId
    );
    commit(AUTH_SETTINGS, await resp.data);
    return resp.data;
  },

  [AUTH_SETTINGS_BY_PREMISE]: async ({ commit }, premiseId) => {
    const resp = await api.auth.getSettingsAuthByPremise(premiseId);
    commit(AUTH_SETTINGS, await resp.data);
    return resp.data;
  },

  [AUTH_LOGIN]: async ({ commit }, user) => {
    const { add } = user;
    const resp = await api.auth.login({ user });
    if (add) {
      commit(AUTH_LOGIN, { key: resp.data.key, username: user.username });
    }

    return resp.data;
  },

  [AUTH_LOGOUT]: ({ commit }) => {
    commit(AUTH_LOGOUT);
    commit(AUTH_SETTINGS, {});
    commit(GET_PERSONAL_ACCOUNT_INFO, {});
    commit(GET_MANAGE_ORGANIZATION_INFO, {});
  }
};
